export default __webpack_public_path__ + "static/media/947.4608848f.jpg";